import { Icon } from "@iconify/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ClinicalFinding from "./ClinicalFinding";
import GeneralPatient from "./GeneralPatient";
import LicensePatient from "./LicensePatient";

const PatientEditProfile = () => {
  const { patientId } = useParams();
  const [patient, setPatient] = useState(null);
  const [packages, setPackages] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [selectedDiv, setSelectedDiv] = useState(0); // Default to 0 for 'General'

  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/user/${patientId}`, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("careSeeAccessToken")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setPatient(data?.data));
  }, [patientId, refetch]);

  useEffect(() => {
    fetch(
      `https://servercareseebd.careseebd.com/api/v1/package/specific?fieldName=${"userId"}&&fieldValue=${patientId}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.data?.length) {
          setPackages(data?.data?.[0]);
        }
      });
  }, [patientId, refetch]);

  const tabs = [
    {
      id: 0,
      label: "General Settings",
      icon: "solar:user-id-linear",
      activeIcon: "solar:user-id-bold",
    },
    {
      id: 2,
      label: "License & Packages",
      icon: "solar:wallet-money-linear",
      activeIcon: "solar:wallet-money-bold",
    },
    {
      id: 1,
      label: "Clinical Findings",
      icon: "solar:document-text-linear",
      activeIcon: "solar:document-text-bold",
    },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header card with back button */}
      <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm flex flex-col sm:flex-row justify-between sm:items-center gap-4">
        <div className="flex items-center gap-4">
          <Link
            to="/doctorDashboard/patients"
            className="p-2.5 border border-slate-200 text-slate-500 hover:text-secondary hover:border-secondary hover:bg-slate-50 rounded-xl transition duration-150"
            title="Back to Patients Directory"
          >
            <Icon icon="solar:alt-arrow-left-linear" className="text-xl" />
          </Link>
          <div>
            <h1 className="text-lg font-bold text-slate-800 tracking-tight flex items-center gap-2">
              <span>Edit Patient Profile</span>
              {patient?.name && (
                <span className="text-sm font-medium text-slate-400 bg-slate-100 px-2.5 py-0.5 rounded-lg">
                  {patient.name}
                </span>
              )}
            </h1>
            <p className="text-xs text-slate-400 font-medium mt-0.5">
              Modify account parameters, purchase subscriptions, and log clinical reports.
            </p>
          </div>
        </div>
      </div>

      {/* Tabs navigation panel */}
      <div className="bg-white p-2.5 rounded-2xl border border-slate-100 shadow-sm">
        <div className="flex flex-col sm:flex-row gap-2">
          {tabs.map((tab) => {
            const isActive = selectedDiv === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setSelectedDiv(tab.id)}
                className={`flex-1 flex items-center justify-center gap-2 px-5 py-3 rounded-xl text-sm font-bold transition duration-200 ${isActive
                  ? "bg-secondary text-white shadow-md shadow-indigo-900/10"
                  : "text-slate-650 hover:bg-slate-50 hover:text-slate-850"
                  }`}
              >
                <Icon
                  icon={isActive ? tab.activeIcon : tab.icon}
                  className="text-lg"
                />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Active Tab Screen */}
      <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        {selectedDiv === 1 && <ClinicalFinding patientId={patientId} />}
        {selectedDiv === 0 && <GeneralPatient patientId={patientId} />}
        {selectedDiv === 2 && (
          <LicensePatient
            patientId={patientId}
            patient={patient}
            setRefetch={setRefetch}
            packages={packages}
          />
        )}
      </div>
    </div>
  );
};

export default PatientEditProfile;
